import type { OnchainEvent } from "@/api/client";

const EXPLORER = "https://sepolia.basescan.org";

const KIND_META: Record<string, { icon: string; label: string }> = {
  deploy: { icon: "📦", label: "Deploy de contrato" },
  transfer: { icon: "💸", label: "Transferência" },
  vesting_create: { icon: "📅", label: "Vesting criado" },
  vesting_claim: { icon: "💰", label: "Saque de vesting" },
  approve: { icon: "✅", label: "Aprovação" },
  other: { icon: "🔗", label: "Transação" },
};

function short(addr: string | null): string {
  if (!addr) return "—";
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

/**
 * Lista de atividade on-chain com links pro Basescan. Reusada pelo painel
 * do sócio (txs da wallet dele) e do admin (tudo / por projeto).
 */
export function OnchainActivity({ events, emptyHint }: { events: OnchainEvent[]; emptyHint?: string }) {
  if (events.length === 0) {
    return (
      <div className="app-card border-app-border p-8 text-center text-app-muted text-sm">
        {emptyHint ?? "Nenhuma transação on-chain ainda."}
      </div>
    );
  }

  return (
    <div className="app-card overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-app-surface-2">
          <tr className="border-b border-app-border text-left text-xs uppercase text-app-muted">
            <th className="px-3 py-2">Evento</th>
            <th>De → Para</th>
            <th>Contrato</th>
            <th>Quando</th>
            <th className="pr-3 text-right">Basescan</th>
          </tr>
        </thead>
        <tbody>
          {events.map((e) => {
            const meta = KIND_META[e.kind] ?? KIND_META.other;
            return (
              <tr key={e.id} className="border-b border-app-border last:border-0 align-top">
                <td className="px-3 py-2">
                  <div className="font-medium">{meta.icon} {e.description}</div>
                  <div className="text-xs text-app-muted">
                    {meta.label}{e.slug ? ` · ${e.slug}` : ""}
                  </div>
                </td>
                <td className="py-2 font-mono text-xs">
                  {e.fromAddr || e.toAddr ? (
                    <>{short(e.fromAddr)} <span className="text-app-muted">→</span> {short(e.toAddr)}</>
                  ) : "—"}
                </td>
                <td className="py-2 font-mono text-xs">
                  {e.address ? (
                    <a className="text-app-accent underline" target="_blank" rel="noreferrer"
                       href={`${EXPLORER}/address/${e.address}`}>{short(e.address)}</a>
                  ) : "—"}
                </td>
                <td className="py-2 text-xs text-app-muted whitespace-nowrap">
                  {new Date(e.createdAt).toLocaleString("pt-BR")}
                </td>
                <td className="pr-3 py-2 text-right">
                  <a className="text-app-accent underline text-xs" target="_blank" rel="noreferrer"
                     href={`${EXPLORER}/tx/${e.txHash}`}>ver tx ↗</a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
